<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.premium-features') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-col cols="12">
                <v-table density="compact">
                    <thead>
                        <tr>
                            <th class="text-left">
                                {{ $t('global.form.name') }}
                            </th>
                            <th class="text-left">
                                id
                            </th>
                            <th class="text-right">
                                {{ $t('actions') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="feature in features" :key="feature.name">
                            <td>{{ feature.name }}</td>
                            <td>{{ feature.id }}</td>
                            <td class="text-right">
                                <v-tooltip>
                                    <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" size="small" @click="() => openDialog(feature)">mdi-magnify</v-icon>
                                    </template>
                                    <span>{{ $t('global.menu.backoffice.findShopWithFeature', { feature: feature?.name }) }}</span><br>
                                </v-tooltip>
                                
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-col>
            <v-col cols="12" class="pt-0 pl-5">
                <v-row cols="12" align="center" justify="center">
                    <v-col>
                        <v-text-field variant="outlined" density="compact" :hide-details="true">
                        </v-text-field>
                    </v-col>
                    <v-btn variant="flat" class="text-right" color="primary">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>

        <FindShopByFeatureDialog v-model="showDialog" v-model:data="selectedFeature"></FindShopByFeatureDialog>

    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import FindShopByFeatureDialog from './modals/FindShopByFeatureDialog.vue';

export default {
    components: {
        FindShopByFeatureDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const selectedFeature = ref(null)
        const showDialog = ref(null)

        const openDialog = (item) => {
            selectedFeature.value = item;
            showDialog.value = true;
        }

        const findActiveShopsWithFeature = async (id, labels) => {
            // {premiumFeatures: ["only-online-shop"], cityIDs: ["M"], resultsPerPage: 500} POST /public/shop/query
            const obj = { labelIds: labels.map(item => item.id) }
            // try {
            //     const response = await proxy.$axios.put(`/shop/${id}/labels`, obj,
            //         {
            //             headers: {
            //                 'X-Auth-HARDTOKEN': hardToken,
            //                 'X-Auth-SOFTTOKEN': softToken,
            //                 'X-Auth-USER': username
            //             },
            //         },
            //     );
            //     // if (response.data.status == "OK") {
            //     //     proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage });
            //     // }
            // } catch (error) {
            //     console.error("Error: ", error);
            // } finally {
            //     showTargetDialog.value = false;
            // }
        }

        const areas = inject('areas');

        watch(() => areas, (newValue) => {
            console.log(newValue);
        }, { immediate: true });

        return {
            selectedLanguage,
            selectedFeature,
            showDialog,
            openDialog,
            findActiveShopsWithFeature,
        };
    },

    watch: {

    },

    data: () => ({
        features: []
    }),

    computed: {
    },

    mounted() {
        this.fetchFeatures();
    },

    methods: {
        fetchFeatures() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get("/backoffice/features", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
            })
                .then(this.featuresFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        featuresFetched(response) {
            this.features = response.data.data;
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 900px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>